import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import PasswordStrengthBar from 'react-password-strength-bar';
import React from 'react';
import toastr from 'toastr';
/** import third-party libraries in the section above, Sort Lines Ascending */

import { ButtonGroup, PrimaryButton } from 'widgets-v5/buttons';
import Card from 'widgets-v5/card';
import CenterLayout from 'widgets-v5/center-layout';
import FormField from 'widgets-v5/form-field';
/** import widgets in the section above, Sort Lines Ascending */

import { getApiErrorMessage } from 'utils/http/get-api-error-message';
import { redirectLoggedInUserFromTokenLink, redirectIfMissingToken } from 'common/token-link-guard';
import PasswordActions from 'states/resources/password/actions';
import selector from './selector';
/** import single application imports in the section above, Sort Lines Ascending */

class ResetPassword extends React.Component {
    state = { formError: null, password: '', passwordStrength: 0 };

    componentDidMount() {
        // Check if user is already logged in — redirect with warning toast if so
        if (
            redirectLoggedInUserFromTokenLink(
                this.props.profile,
                (this.props.location.query?.token || '').trim()
            )
        ) {
            return;
        }

        // Validate token in URL — redirect to home with error toast if missing

        if (redirectIfMissingToken(this.props.location)) {
            return;
        }
    }

    handleSubmit = e => {
        e.preventDefault();

        this.setState({ formError: null });

        const reset_token = this.props.location.query.token;
        const password = this.refs.password.value;
        const confirm = this.refs.confirm.value;

        if (!password) {
            return this.setState({ formError: 'A new password is required' });
        }

        const need12characters = password.length < 12;
        if (need12characters) {
            return this.setState({ formError: 'Password must be at least 12 characters' });
        }

        if (this.state.passwordStrength < 2) {
            return this.setState({
                formError: 'Password is too weak. Please use a stronger password.',
            });
        }

        const notMatch = password !== confirm;
        if (notMatch) {
            return this.setState({ formError: 'Confirmation password must match' });
        }

        this.props.dispatch(PasswordActions.reset(password, reset_token)).then(
            () => {
                browserHistory.push(`/`);
                toastr.success('Your password has been reset');
            },
            err => {
                let errorMessage = getApiErrorMessage(err, 'Password reset failed');
                if (err.body === 'Reusing old password') {
                    errorMessage =
                        'Password is the same as a previous password. Please create a new one.';
                } else if (err.code === 403) {
                    errorMessage =
                        'User is disabled. If you are unable to access your account, please contact us at help@engagefront.com';
                } else if (err.code === 404) {
                    errorMessage =
                        'Invalid or expired token. Please retry the reset password process.';
                }

                this.setState({
                    formError: errorMessage,
                });
            }
        );
    };

    render() {
        const formError = this.state.formError;
        return (
            <CenterLayout className="ef5-reset-password">
                <div>
                    <img className="ef5-reset-password__logo" src="/images/EngageFront-logo.png" />
                    <Card
                        className="ef5-reset-password__card"
                        title="Reset Password"
                        footer={
                            <ButtonGroup>
                                <PrimaryButton text="Reset Password" onClick={this.handleSubmit} />
                            </ButtonGroup>
                        }
                    >
                        <form ref="login-form" method="POST" onSubmit={this.handleSubmit}>
                            <p className="ef5-reset-password__instructions">
                                Enter a new password for your account
                            </p>
                            <FormField label="Password" isRequired={true}>
                                <input
                                    className="ef3-stdInput"
                                    type="password"
                                    ref="password"
                                    name="password"
                                    onChange={e => this.setState({ password: e.target.value })}
                                />
                                <PasswordStrengthBar
                                    className="ef5-reset-password__strength-meter"
                                    minLength={12}
                                    password={this.state.password}
                                    onChangeScore={score =>
                                        this.setState({ passwordStrength: score })
                                    }
                                />
                            </FormField>
                            <br />
                            <FormField
                                label="Password Confirmation"
                                isRequired={true}
                                showErrors={!!formError}
                                errors={[formError]}
                            >
                                <input
                                    className="ef3-stdInput"
                                    type="password"
                                    ref="confirm"
                                    name="confirm"
                                />
                            </FormField>
                        </form>
                    </Card>
                </div>
            </CenterLayout>
        );
    }
}

export default connect(selector)(ResetPassword);
